import React, { useRef, useState } from 'react'
import Background from '../../assets/backgrounds/partnerships.svg'
import BackgroundMobile from '../../assets/backgrounds/partnerships-mobile.svg'
import PageHeader from '../../partials/PageHeader'
import { Color } from '../../utils/constants'
import InformationBlock from '../../partials/InformationBlock'
import HowItWorks from './components/HowItWorks'
import Partners from '../../partials/Partners'
import PartnerWithUs from './components/PartnerWithUs'
import Testimonials from '../../partials/Testimonials/Testimonials'
import Process from './components/Process'
import PaddingContext, { PaddingProps } from '../../utils/PaddingContext'

const Partnerships = () => {
    const [padding, setPadding] = useState<PaddingProps>()
    return (
        <PaddingContext.Provider value={{ padding }}>
            <PageHeader
                title='page.partnerships.title'
                description='page.partnerships.description'
                bgColor={Color.GREEN_LIGHT}
                component={Background}
                mobileComponent={BackgroundMobile}
                link={'/'}
            />
            <div className='bg-white'>
                <HowItWorks />
                <Testimonials setPadding={setPadding} />
                <Partners>
                    <div className='w-full h-px bg-black/10' />
                </Partners>
                <PartnerWithUs />
                <Process />
                <InformationBlock
                    title='page.partnerships.partnering'
                    description='page.partnerships.partnering.description'
                    link='/contact'
                />
            </div>
        </PaddingContext.Provider>
    )
}

export default Partnerships
